import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

interface PopupContextProps {
  isSaveOfferFormVisible: boolean;
  isResultPopupVisible: boolean;
  resultPopupHeader: string;
  resultPopupText: string | string[];
  resultPopupImage: string;
  saveOfferMode: "offer" | "purchase";
  setIsSaveOfferFormVisible: (isSaveOfferFormVisible: boolean) => void;
  setIsResultPopupVisible: (isResultPopupVisible: boolean) => void;
  setResultPopupHeader: (resultPopupHeader: string) => void;
  setResultPopupText: (resultPopupText: string | string[]) => void;
  setResultPopupImage: (resultPopupImage: string) => void;
  setSaveOfferMode: (mode: "offer" | "purchase") => void;
}

const PopupContext = createContext<PopupContextProps | null>(null);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isSaveOfferFormVisible, setIsSaveOfferFormVisible] = useState(false);
  const [isResultPopupVisible, setIsResultPopupVisible] = useState(false);
  const [resultPopupHeader, setResultPopupHeader] = useState("");
  const [resultPopupText, setResultPopupText] = useState<string | string[]>("");
  const [resultPopupImage, setResultPopupImage] = useState("");
  const [saveOfferMode, setSaveOfferMode] = useState<"offer" | "purchase">("offer");

    return (
    <PopupContext.Provider
      value={{
        isSaveOfferFormVisible,
        isResultPopupVisible,
        resultPopupHeader,
        resultPopupText,
        resultPopupImage,
        saveOfferMode,
        setIsSaveOfferFormVisible,
        setIsResultPopupVisible,
        setResultPopupHeader,
        setResultPopupText,
        setResultPopupImage,
        setSaveOfferMode,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = (): PopupContextProps => {
  const context = useContext(PopupContext);

  if (!context) {
    throw new Error("usePopup must be used within a ViewProvider");
  }

  return context;
};
